import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../modules/booking/actions";
import { GOURMET, CITY_BOOKING } from "../../constants/app";
import GourmetBooking from "./custom";
import Booking from "./index";

const BookingContainer = (props) => {
  const { auth } = props;
  const isGourmet = auth.user.category_type === GOURMET;
  const isCityBooking = auth.user.city_name === CITY_BOOKING;
  const isGourmetAndCityBooking = isGourmet && isCityBooking;
  if (isGourmetAndCityBooking) {
    return <GourmetBooking />;
  }
  return <Booking />;
};

const mapStateToProps = (state) => {
  return {
    booking: state.booking,
    auth: state.auth,
    setting: state.setting,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingContainer);
